<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g clip-path="url(#clip0_3900_37465)">
      <path
        d="M9.99967 8.49992C10.2758 8.49992 10.4997 8.27606 10.4997 7.99992C10.4997 7.72378 10.2758 7.49992 9.99967 7.49992H5.99967C5.72353 7.49992 5.49967 7.72378 5.49967 7.99992C5.49967 8.27606 5.72353 8.49992 5.99967 8.49992H9.99967Z"
        fill="#454545"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99967 0.833252C4.04163 0.833252 0.833008 4.04188 0.833008 7.99992C0.833008 11.958 4.04163 15.1666 7.99967 15.1666C11.9577 15.1666 15.1663 11.958 15.1663 7.99992C15.1663 4.04188 11.9577 0.833252 7.99967 0.833252ZM1.83301 7.99992C1.83301 4.59416 4.59392 1.83325 7.99967 1.83325C11.4054 1.83325 14.1663 4.59416 14.1663 7.99992C14.1663 11.4057 11.4054 14.1666 7.99967 14.1666C4.59392 14.1666 1.83301 11.4057 1.83301 7.99992Z"
        fill="#454545"
      />
    </g>
    <defs>
      <clipPath id="clip0_3900_37465">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
